import React from "react";
import { Card, CardBody, Badge, Row, Col } from "reactstrap";

const EnelTab = ({ contact }) => {
  const catastros = contact.catastros_enel || [];

  const getClaseBadge = (clase) => {
    const colors = {
      "Residencial": "success",
      "Comercial": "primary",
      "Industrial": "warning",
      "Oficial": "info"
    };
    return colors[clase] || "secondary";
  };

  const getEstadoBadge = (estado) => {
    return estado === "Activo" ? "success" : "danger";
  };

  return (
    <CardBody className="p-0">
      <h5 className="mb-4">Información Catastral ENEL</h5>
      
      {catastros.length === 0 ? (
        <div className="text-center py-4">
          <p>No se encontró información catastral</p>
        </div>
      ) : (
        <Row>
          {catastros.map((catastro, index) => (
            <Col key={index} md={6} className="mb-4">
              <Card className="h-100">
                <CardBody>
                  {/* Encabezado con número de cuenta */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">Cuenta: <strong>{catastro.nro_cuenta || "N/A"}</strong></h6>
                    <Badge color={getClaseBadge(catastro.clase)} pill>
                      {catastro.clase || "Sin clase"}
                    </Badge>
                  </div>

                  <Row>
                    {/* Columna izquierda - Información principal */}
                    <Col sm={6}>
                      <div className="mb-3">
                        <p className="mb-1"><strong>Subclase:</strong></p>
                        <p>{catastro.subclase || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <p className="mb-1"><strong>Zona:</strong></p>
                        <p>{catastro.zona || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <p className="mb-1"><strong>Grupo:</strong></p>
                        <p>{catastro.grupo || "N/A"}</p>
                      </div>
                    </Col>

                    {/* Columna derecha - Información técnica */}
                    <Col sm={6}>
                      <div className="mb-3">
                        <p className="mb-1"><strong>Marca:</strong></p>
                        <p>{catastro.marca || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <p className="mb-1"><strong>Medidor:</strong></p>
                        <p>{catastro.nro_medidor || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <p className="mb-1"><strong>Estado:</strong></p>
                        <Badge color={getEstadoBadge(catastro.estado)}>
                          {catastro.estado || "N/A"}
                        </Badge>
                      </div>
                    </Col>
                  </Row>

                  {/* Sección adicional para otros datos si existen */}
                  {(catastro.observaciones || catastro.direccion) && (
                    <div className="mt-3 pt-3 border-top">
                      {catastro.direccion && (
                        <div className="mb-2">
                          <p className="mb-1"><strong>Dirección:</strong></p>
                          <p className="text-muted">{catastro.direccion}</p>
                        </div>
                      )}
                      {catastro.observaciones && (
                        <div>
                          <p className="mb-1"><strong>Observaciones:</strong></p>
                          <p className="text-muted">{catastro.observaciones}</p>
                        </div>
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </CardBody>
  );
};

export default EnelTab;